import React, { Component } from 'react';
import KeyValue from './KeyValue';
import { PathLink } from './PathLink';

function _imgContainer(img)
{
    return (
    <div className="col-fixed" style={{height: '110px'}}>
    {img}
    </div>
    );
}
function EntityPanel(props) {
  var img=<></>;
  if(props.img)
    img=_imgContainer(props.img);
  
  return(
  <div>
  <div className="grid m-1">
        {img}
		<div className="col flex flex-column justify-content-between align-items-start pt-1 pb-1">
            <h4>{props.header}</h4>
            <KeyValue values={props.values}>
            </KeyValue>
		</div>
		<div className="col-fixed flex flex-column justify-content-between align-items-end pt-1 pb-1" style={{width:'120px'}}>
			<div className="flex text-right">{props.icon}</div>
		</div>
	</div>
  {
    props.pathItems.length>1?
    <PathLink items={props.pathItems} nav={props.nav} onSelect={props.onSelect}/>:<></>
  }
  </div>
	)
}

export default EntityPanel;